var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:{border: _vm.showBorder},attrs:{"id":"appleLoginButton"},on:{"click":_vm.login}},[_c('img',{attrs:{"src":"https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"}}),(_vm.isLogin)?_c('span',[_vm._v("Sign in with Apple")]):_c('span',[_vm._v("Sign up with Apple")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }